export const NXMEvents = {
  Approve: 'NXM.Approve',
  ApproveCompleted: 'NXM.ApproveCompleted',

  GetBalance: 'NXMToken.GetBalance',
  BalanceReturned: 'NXMToken.BalanceReturned',

  GetAllowance: 'NXMToken.GetAllowance',
  AllowanceReturned: 'NXMToken.AllowanceReturned',
}
